const ColGroupFooter = () => (
    <colgroup>
            <col style={{width: "15%"}}/>
            {/* Stocks */}
            <col style={{width: "11%"}}/>
            {/* Today's Gain */}
            <col style={{width: "16.35%"}}/>
            {/* Overall Gain */}
            <col style={{width: "0.1%"}}/>
            {/* empty */}
            <col style={{width: "16.1%"}}/>
            {/* Current Value */}
            <col style={{width: "14%"}}/>
            {/* Quantity */}
            <col style={{width: "13.45%"}}/>
            {/* Invested */}
            <col style={{width: "12%"}}/>
            {/* Price */}
    </colgroup>
);

export default ColGroupFooter;
